export const pagination = {
    page: 1,
    per_page: 20,
    total: 0,
};